import * as React from 'react'

export interface Props {
  id: string
  arrowNextClass?: string
  arrowPrevClass?: string
  interval?: number
  children?: React.ReactNode
}

export interface State {}

export default class CarouselSlide extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }

  static defaultProps = {
    arrowNextClass: '',
    arrowPrevClass: '',
  }

  render() {
    return (
      <div id={this.props.id} className="carousel slide" data-ride="carousel" data-interval={this.props.interval}>
        <div className="carousel-inner">
          {React.Children.map(this.props.children, (child, index) => {
            let className = 'carousel-item'
            if (index === 0) {
              className += ' active'
            }
            return <div className={className}>{child}</div>
          })}
        </div>

        <a
          className={`carousel-control-prev ${this.props.arrowPrevClass}`}
          href={`#${this.props.id}`}
          role="button"
          data-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="sr-only">Previous</span>
        </a>
        <a
          className={`carousel-control-next  ${this.props.arrowNextClass}`}
          href={`#${this.props.id}`}
          role="button"
          data-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="sr-only">Next</span>
        </a>
      </div>
    )
  }
}
